import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { UserAddress } from '../../types/user-address';

type UseCaseInput = UserAddress;

type UseCaseOutput = void;

export class SetSelectedAddressUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    if (!input) {
      throw new Error('Endereço é obrigatório');
    }

    if (!input.id || !input.street || !input.city) {
      throw new Error('Endereço inválido: campos obrigatórios ausentes');
    }

    if (input.id.trim() === 'geolocation') {
      throw new Error('Não é possível salvar endereço de geolocalização');
    }

    localStorage.setItem('selected-address', JSON.stringify(input));
  }
}
